<template>
	<div class="merchant_content">
		<div class="detail_title" @click="$router.go(-1)">
			<span class="icon LEFTARROW mr_8"></span>
			<h3 class="title_m">{{ $t('merchant.menu_2.menu4') }}</h3>
		</div>
		<accordion v-for="item in faqList" :key="item.seq" class="faq">
			<accordion-item>
				<template v-slot:accordion-trigger>
					<div class="d_flex align_items_center">
						<span class="HELP icon mr_8"></span>
						<p>{{ item.title }}</p>
					</div>
				</template>

				<template v-slot:accordion-content>
					<div class="notice-accordion-content">
						<p class="answer" v-html="item.content"></p>
					</div>
				</template>
			</accordion-item>
		</accordion>
		<!--    <pagination-->
		<!--        :totalCount="pageNavigation.total_count"-->
		<!--        :totalPage="pageNavigation.total_page"-->
		<!--        :curPage="pageNavigation.cur_page"-->
		<!--        :point="pageNavigation.point"-->
		<!--        :firstPage="pageNavigation.first_page"-->
		<!--        :lastPage="pageNavigation.last_page"-->
		<!--        @change="pageChangeHandler"-->
		<!--    ></pagination>-->
	</div>
</template>
<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
// import pagination from '@/components/Pagination';
import { fetchFaqList } from '@/api/cs';
import { commonError } from '@/common/dialog';
export default {
	name: 'SetupFaq',
	components: {
		Accordion,
		AccordionItem,
		// pagination,
	},
	data() {
		return {
			faqList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadFaqList();
		},
		async loadFaqList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.faqList = data;
			this.pageNavigation = page_navigation;
		},
		// pageChangeHandler(pageNo) {
		// 	this.curPage = pageNo;
		// 	this.loadNoticeList();
		// },
	},
};
</script>

<style></style>
